<template>
    <div :style="{ height: `${data?.props?.height || 16}px` }"></div>
  </template>
  
  <script>
  export default {
    name: 'SpacerBlock',
    props: {
      data: Object,
    },
  };
  </script>
  

  
  